import {connect} from 'react-redux';
import {createSelector} from 'reselect';
import camelCase from 'lodash/camelCase';
import includes from 'lodash/includes';
import compose from 'recompose/compose';
import setDisplayName from 'recompose/setDisplayName';
import Checkbox from 'components/forms/BasicFormFields/Checkbox';
import {SectionedColumns} from './utils';

// selects the correct props for Checkbox based on section
const createCheckboxPropsSelector = sectionName => createSelector(
  state => state.userManagement,
  ({tableColumns, tableColumnsInProgress}) => {
    const sectionFields = SectionedColumns[sectionName];

    // current draft of visible table columns, in legible form for Checkbox
    const value = tableColumnsInProgress
      .filter(({name, visible}) => includes(sectionFields, name) && visible)
      .map(({name}) => name);

    // Checkbox options
    const options = tableColumns
      .filter(({name}) => includes(sectionFields, name))
      .map(({name, disabled}) => ({
        key: name,
        value: name,
        textKey: `humanologyHubUsers.usersList.column.${camelCase(name)}`,
        disabled
      }));

    return {
      colWidth: 8,
      value,
      options
    };
  }
);

export default compose(
  connect((state, props) => createCheckboxPropsSelector(props.name)(state)),
  setDisplayName('VisualColumnsCheckbox')
)(Checkbox);



// WEBPACK FOOTER //
// ./public/pages/UserManagement/VisibleColumnsCheckbox.js